module.exports = __webpack_public_path__ + "static/media/AdminSkinListBackground.d5e4bc18.png";